import React, { Component } from 'react';

import img1 from '../../assets/img/clients/1.png';
import img2 from '../../assets/img/clients/2.png';
import img3 from '../../assets/img/clients/3.png';
import img4 from '../../assets/img/clients/4.png';
import img5 from '../../assets/img/clients/5.png';
import img6 from '../../assets/img/clients/6.png';
import img7 from '../../assets/img/clients/7.png';
import img8 from '../../assets/img/clients/8.png';
import img9 from '../../assets/img/clients/9.png';
import img10 from '../../assets/img/clients/10.png';
import img11 from '../../assets/img/clients/11.png';
import img12 from '../../assets/img/clients/12.png';

const clientspost = [
    { img: img1 },
    { img: img2 },
    { img: img3 },
    { img: img4 },
    { img: img5 },
    { img: img6 },
    { img: img7 },
    { img: img8 },
    { img: img9 },
    { img: img10 },
    { img: img11 },
    { img: img12 },
];

class Clients extends Component {
    render() {
        return (
            <div className="section pt-0">
                <div className="container">
                    <div className="row no-gutters">
                        {clientspost.map((item, i) => (
                            <div className="col-lg-2 col-md-3 col-6 p-0" key={i}>
                                <div className="sigma_client">
                                    <img src={item.img} alt="" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div >
        );
    }
}

export default Clients;